module.exports = __webpack_public_path__ + "img/10-map.0969681e.jpg";